import { combineReducers } from "redux";
import deviceReducer from "./device-reducer";
import reportReducer from "./report-reducer";
import eventReducer from "./event-reducer";
import sessionReducer from "./session-reducer";
import inviteUserReducer from "./inviteUser-reducer";
import cameraonboardingReducer from "./cameraonboarding-reducer";
import cameraOnboardingReducer from "./cameraOnboaring-reducer";
import polygonRoiReducer from "./polygon-reducer";
import addGroupReducer from "./addGroup-reducer";
import undoable from "redux-undo";
import polygonReducer from "../slices/polygonSlice";
import sitesReducer from "./sites-reducer";
import statisticsReducer from "./knowi-reducer";
import cvAppReducer from "./cvapp-reducer";
import userDetailsGroupReducer from "./userDetailsGroupReducer";
import ruleReducer from "./rule-reducer";
import alertsListReducer from "./alertsList-reducer";
import { inviteUserModalReducer } from "./userInviteModal-reducer";
import widgetReducer from "./widget-reducer";
import errorReducer from "./error-reducer";
import notificationBannerReducer from "./notificationBanner-reducer";
import calibrationBannerReducer from "./calibrationBanner-reducer";
import licenseReducer from "./license-reducer";
import eventSettingsReducer from "./event-settings-reducer";
import idleTimeModalReducer from "./idleTimeModal-reducer";
import { types } from "../actions";
import imagesReducer from "./images-reducer";
import userRoleReducer from "./user-role-reducer";
import eventPageNumberReducer from "./eventPageNumberReducer";
import availableIncidentsReducer from "./availableIncidents-reducer";
import enrolledAppearanceReducer from "./ea-reducer";
import tableFilterReducer from "./table-filter-reducer";
import forensicSearchReducer from "./forensicSearch-reducer";
import userManagementReducer from "./userManagement-reducer";
import chatbotReducer from "./chatbot-reducer";
import userAppSettingsReducer from "./userAppSettings-reducer";
import assistantPromptsReducer from "./assistantPrompts-reducer";

const appReducer = combineReducers({
  chatbot: chatbotReducer,
  assistantPrompts: assistantPromptsReducer,
  availableIncidentsReducer,
  userRoleReducer,
  eventPageNumberReducer,
  forensicSearchReducer,
  eventSettingsReducer,
  deviceReducer,
  reportReducer,
  eventReducer,
  imagesReducer,
  licenseReducer,
  inviteUserReducer,
  cameraonboardingReducer,
  cameraOnboardingReducer,
  addGroupReducer,
  userDetailsGroupReducer,
  sessionReducer,
  sitesReducer,
  polygonRoiReducer,
  statisticsReducer,
  cvAppReducer,
  widgetReducer,
  inviteUserModalReducer,
  ruleReducer,
  alertsListReducer,
  errorReducer,
  idleTimeModalReducer,
  enrolledAppearanceReducer,
  tableFilterReducer,
  notificationBanner: notificationBannerReducer,
  calibrationBanner: calibrationBannerReducer,
  userManagementReducer,
  userAppSettingsReducer,
  tableFilterReducer,
  polygon: undoable(polygonReducer, {
    filter: function filterActions(action) {
      return (
        action.type === "polygon/setPolygons" &&
        action.payload.shouldUpdateHistory
      );
    },
  }),
});

const rootReducer = (state, action) => {
  if (action.type === types.RESET_APP) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
